module.exports = __webpack_public_path__ + "media/localization/english-5d97f4c1.png";